import React from 'react'
import styled, { CSSProperties } from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'
//
//
const Title: React.FC<{ text?: string; style?: CSSProperties }> = ({ text, style }) => {
  return <Text style={style}>{text}</Text>
}
//
const Text = styled.h6`
  font-size: 36px;
  color: ${Colors.primaryBlack};
  text-align: center;
  margin-bottom: 30px;

  ${Responsive.mobile} {
    font-size: 18px;
    margin-bottom: 24px;
  }
`
//
export default Title
